module.exports = __webpack_public_path__ + "static/LogisticsDevice-e3c5e667fd7c3e72dcbf8ea88e3c2f0a.png";